import React from "react";
import { Link } from "react-router-dom";
import { Building2, ArrowRight } from "lucide-react";
import EmptyState from "./EmptyState.js";

// Empty state shown on every tenant-scoped page when a super_admin is
// logged in but hasn't yet picked an acting tenant. The "選擇單位"
// shortcut button is the whole point — without it admins land on
// e.g. /dashboard/routes, see "請到平台/租戶頁" text, then have to dig
// through the side nav to find it. Same icon / copy / button across
// pages so the experience is uniform.
export default function TenantPickerEmptyState(): React.ReactElement {
  return (
    <EmptyState
      icon={Building2}
      title="尚未選定要進入的單位"
      description="您是平台管理員。請到「平台 / 租戶」頁，選擇要操作的客戶單位。"
      action={
        <Link to="/dashboard/platform/tenants" className="btn-primary text-sm inline-flex items-center gap-1">
          選擇單位 <ArrowRight className="h-4 w-4" />
        </Link>
      }
    />
  );
}
